import fetchIntercept from "fetch-intercept";
import { addToStack, removeFromStack } from "./hooks/blockingHook";
import { getToken, validateToken } from "./hooks/authHook";

export const registerInterceptor = fetchIntercept.register({
  request: function (url, config) {
    const isExternalURL = !url.includes(process.env.REACT_APP_API_URL);

    if (config) {
      const token = getToken();
      if (!config.headers) config.headers = {};
      config.headers.Authorization = "Bearer " + token.access;

      if ( !isExternalURL && !config.headers.NoBlocking) {
        addToStack(url);
      }

      if (!isExternalURL && !config.headers.SkipValidationToken) validateToken(token);
    }
    return [url, config];
  },

  requestError: function (error) {
    // Called when an error occured during another 'request' interceptor call
    removeFromStack(error.url);
    return Promise.reject(error);
  },

  response: function (response) {
    // Modify the reponse object

    removeFromStack(response.url);

    if (response.status === 401) {
      const token = getToken();
      validateToken(token);
    }

    return response;
  },

  responseError: function (error) {
    // Handle an fetch error
    removeFromStack(error.url);
    return Promise.reject(error);
  },
});